import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, LoginGuard } from './auth/auth.guard';
import { AiChatComponent } from './pages/ai-chat/ai-chat.component';

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule),
    canActivate: [LoginGuard]
  },
  {
    path: "",
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule) , canActivate: [AuthGuard]
  },
  { path: 'ai-chat', component: AiChatComponent },
  {
    path: "**",
    redirectTo: '',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
